<template>
  <div>
    <div v-if="isLoading" class="text-center">
      <i class="fa fa-spinner fa-spin" />
    </div>
    <div v-else-if="!node" class="text-center">
      <p>This node could not be found.</p>
      <router-link to="/nodes">Back</router-link>
    </div>
    <div v-else>
      <Panel v-if="node.node.type === $consts.NODE_TYPE_MAP.panel" :panel="node" />
      <Mcc v-else-if="node.node.type === $consts.NODE_TYPE_MAP.mcc" :mcc="node" />
      <Vfd v-else-if="node.node.type === $consts.NODE_TYPE_MAP.vfd" :vfd="node" />
      <Breaker v-else-if="node.node.type === $consts.NODE_TYPE_MAP.breaker" :breaker="node" />
      <Starter v-else-if="node.node.type === $consts.NODE_TYPE_MAP.starter" :starter="node" />
      <SoftStart v-else-if="node.node.type === $consts.NODE_TYPE_MAP.softstart" :softstart="node" />
      <DistributionPanelboard v-else-if="node.node.type === $consts.NODE_TYPE_MAP.distributionPanelboard" :dp="node" />
      <Switchboard v-else-if="node.node.type === $consts.NODE_TYPE_MAP.switchboard" :switchboard="node" />
      <Transformer v-else-if="node.node.type === $consts.NODE_TYPE_MAP.transformer" :transformer="node" />
      <DisconnectSwitch v-else-if="node.node.type === $consts.NODE_TYPE_MAP.disconnectSwitch" :disconnectSwitch="node" />
      <Fuse v-else-if="node.node.type === $consts.NODE_TYPE_MAP.fuse" :fuse="node" />
      <AuxNode v-else-if="node.node.type === $consts.NODE_TYPE_MAP.auxNode" :auxNode="node" />
      <!-- <loading-panel :loading="loading" class="save-button-panel">
        <button class="btn btn-primary w-25" @click.prevent="save">Save</button>
        <transition name="fade">
          <div v-if="saveSuccessful" class="text-success">Changes were saved.</div>
        </transition>
      </loading-panel> -->
      <error-panel class="m-auto" :errors="errors"></error-panel>
    </div>
  </div>
</template>

<script>
import Panel from "@/components/node-forms/Panel";
import Mcc from "@/components/node-forms/Mcc";
import Vfd from "@/components/node-forms/Vfd";
import Breaker from "@/components/node-forms/Breaker";
import Starter from "@/components/node-forms/Starter";
import SoftStart from "@/components/node-forms/SoftStart";
import DistributionPanelboard from "@/components/node-forms/DistributionPanelboard";
import Switchboard from "@/components/node-forms/Switchboard";
import Transformer from "@/components/node-forms/Transformer";
import DisconnectSwitch from "@/components/node-forms/DisconnectSwitch";
import Fuse from "@/components/node-forms/Fuse";
import AuxNode from "@/components/node-forms/AuxNode";

export default {
  name: "node",
  components: {
    Panel,
    Mcc,
    Vfd,
    Breaker,
    Starter,
    SoftStart,
    DistributionPanelboard,
    Switchboard,
    Transformer,
    DisconnectSwitch,
    Fuse,
    AuxNode,
  },
  props: ["node", "isLoading"],
  data: () => ({
    loading: false,
    saveSuccessful: undefined,
    saveTimeout: null,
    errors: [],
    filter: ""
  }),
  methods: {
    async save() {
      try {
        this.loading = true;
        const response = await this.$web.updateNode(
          this.node,
          this.node.node.type
        );
        this.saveSuccessful = true;
        this.saveTimeout = setTimeout(
          () => (this.saveSuccessful = false),
          2000
        );
      } catch (err) {
        console.log(err);
        this.errors = ["An error occurred."];
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.save-button-panel {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
</style>
